import ErrorTemplate from "../ErrorTemplate/ErrorTemplate";

const ErrorClassifyRender = (props) => {
  const { ErrorStatus } = props;

  let ActualTemplate = null;

  const Error404 = (
    <ErrorTemplate
      Headline={"404"}
      Subhead={"Aaaaah, ok, small problem."}
      Content={{
        P1: "So, the page you hoped was there… isn’t.",
        P2: "Could be an accidental URL, perhaps the page",
        P3: "sunk, perhaps it’s gone to friday drinks early.",
        P4: "Let’s head back to the dashboards and  ",
        P5: " try it again.",
      }}
      ButtonLink={"/"}
      ButtonText={"Back to dashboards"}
    />
  );

  const Error429 = (
    <ErrorTemplate
      Headline={"429"}
      Subhead={"Limit Reached. We’ve hit a wall here."}
      Body={
        "On your current plan, you’re only allowed a set amount of server requests – and you just hit that limit. " +
        "Your plan will reset at 00:00 AEST, or you can get in contact with us and get raise your limit."
      }
      ButtonLink={"/"}
      ButtonText={"Email Mutinex"}
    />
  );

  const Error500 = (
    <ErrorTemplate
      Headline={"500"}
      Subhead={"Erm, we’ve got a problem"}
      Body={
        "Although, we’re big enough to admit we don’t actually know WHAT the problem is right now. " +
        "But we’re going to get to the bottom of it, if it’s the last thing we do!"
      }
      ButtonLink={"/"}
      ButtonText={"RELOAD"}
    />
  );

  const Error501 = (
    <ErrorTemplate
      Headline={"501"}
      Subhead={"It’s not you, it’s us"}
      Body={
        "Our server is not having a great time right now, but it’s really trying it’s hardest to make you happy. " +
        "We say give it another chance and hit try again (if the problem persists please email) support@mutinex.co)"
      }
      ButtonLink={"/"}
      ButtonText={"TRY AGAIN"}
    />
  );

  const Error401 = (
    <ErrorTemplate
      Headline={"401"}
      Subhead={"Sorry, that’s classified"}
      Body={
        "Hmm, looks like you’ve tried to access something that’s above your pay-grade. " +
        "If you think you deserve an Access All Areas pass, please email support@mutinex.co. " +
        "In the meantime, good luck on that promotion."
      }
      ButtonLink={"/"}
      ButtonText={"Back to Dashboard"}
    />
  );

  const Error403 = (
    <ErrorTemplate
      Headline={"403"}
      Subhead={"You do not have access to this area of the site."}
      Body={
        "You may not have access to this part of the site, or you may not have access to this site at all. Please contact your account admin to arrange access by updating your permission settings."
      }
      ButtonLink={"/"}
      ButtonText={"Logout"}
      hideButton={true}
      showLogoutButton={true}
    />
  );

  const Error440 = (
    <ErrorTemplate
      Headline={"440"}
      Subhead={"Session timeout"}
      Body={
        "You were inactive for a moment too long - for security reasons, please refresh your page to continue."
      }
      ButtonLink={"/"}
      ButtonText={"Refresh"}
    />
  );

  switch (ErrorStatus) {
    case 404:
      ActualTemplate = Error404;
      break;
    case 429:
      ActualTemplate = Error429;
      break;
    case 500:
      ActualTemplate = Error500;
      break;
    case 501:
      ActualTemplate = Error501;
      break;
    case 401:
      ActualTemplate = Error401;
      break;
    case 440:
      ActualTemplate = Error440;
      break;
    case 403:
      ActualTemplate = Error403;
      break;
    default:
      ActualTemplate = Error500;
  }

  return ActualTemplate;
};

export default ErrorClassifyRender;
